<template>
  <div class="changjing">
    <c-tab :tabs="tabs" :key="tableKey">
      <!-- <template slot="notify" v-if="showMessage">
        <i class="el-icon-message"></i>&nbsp;
        <span class="message">{{message}}</span>
      </template> -->

      <template slot="operate">
        <el-button
        type="primary"
        @click="$router.push(`/changjing/edit_contact/0`)"
        v-if="permissionFn"
      >新增名片</el-button>
        <el-button
        type="primary"
        @click="$router.push(`/changjing/edit/0`)"
        v-if="permissionFn"
      >新增渠道</el-button>
      <el-button
        type="primary"
        @click="$router.push(`/changjing/edit_column`)"
        v-if="permissionFn"
      >新增栏目</el-button>
      </template>
    </c-tab>

  </div>
</template>

<script>
import CTab from '@/components/common/tab'
import List from './#list'
import Latest from './#latest'
import Move from './#move'
import Hot from './#hot'
import Overview from './#overview'
import store from '@/store'
import * as types from '@/store/mutation-types'

export default {
  name: 'changjing',
  components: { CTab },
  data() {
    return {
      tableKey: 0,
      active: '0',
      tabs: [{
        label: '概览',
        key: 'overview',
        component: Overview
      }, {
        label: '列表',
        key: 'list',
        component: List
      }, {
        label: '最新',
        key: 'latest',
        component: Latest
      }, {
        label: '最热',
        key: 'hot',
        component: Hot
      }, {
        label: '动态',
        key: 'move',
        component: Move
      }],
      message: 'this is a notify.',
      showMessage: false
    }
  },
  watch: {
    $route: {
      handler: function() {
        const crumbs = {
          path: this.$route.path,
          tabs: this.tabs
        }
        this.$store.commit(types.RECORD_GLOBAL_CRUMBSECOND, crumbs)
      },
      immediate: true
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('fetchChannels').then(() => { next() })
  },
  methods: {
    permissionFn(type) {
      switch (type) {
        // 10 管理员
        case 'admin':
          return this.$store.state.global.previllage === 10
        // previllage: 1,2,10 有读权限就行
        case 'read':
          return [1, 2, 10].includes(this.$store.state.global.previllage)
        // previllage:2 10 有读写权限
        case 'write':
          return [2, 10].includes(this.$store.state.global.previllage)
      }
    }
  }
}
</script>

<style lang="scss">
.el-icon-message {
  font-size: 18px;
  margin-right: -5px;
}
.message {
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 15px;
  color: #fe725b;
}
</style>
